import React, { memo } from 'react'
import { SidePanelContent, SidePanelSection } from './styles'
import { ExpandAndCollapseButton } from '../../ExpandAndCollapseButton'
import { useOpenCloseState, useOpenCloseUpdater } from '~/context'

interface Props {
  children: React.ReactNode
}

export const SidePanel = memo(({ children }: Props): JSX.Element => {
  const { isOpen } = useOpenCloseState()
  const { open, close } = useOpenCloseUpdater()

  const handleToggleSidePanel = (): void => {
    isOpen ? close() : open()
  }

  return (
    <SidePanelSection isCollapsed={!isOpen}>
      <SidePanelContent isCollapsed={!isOpen}>{children}</SidePanelContent>
      <div className="buttonPosition">
        <ExpandAndCollapseButton collapsedDirection="left" isCollapsed={!isOpen} onClick={handleToggleSidePanel} />
      </div>
    </SidePanelSection>
  )
})

SidePanel.displayName = 'SidePanel'
